// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  const footerLinkProps = { target: '_blank', variant: 'caption', sx: { color: 'text.primary' } };
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between', p: '24px 16px 0px', mt: 'auto' }}
    >
      <Typography variant="caption">
        &copy; Todos los derechos reservados{' '}
        <Link href="https://GOYAAI.com/" target="_blank" underline="hover">
          GOYAAI
        </Link>
      </Typography>
      <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between' }}>
        <Link href="https://GOYAAI.com/hire-us/" {...footerLinkProps}>
          Contrátanos
        </Link>
        <Link href="https://mui.com/store/license/" {...footerLinkProps}>
          Licencia
        </Link>
        <Link href="https://mui.com/store/terms/" {...footerLinkProps}>
          Terminos
        </Link>
        <Link href="https://links.GOYAAI.com/dAAOP" {...footerLinkProps}>
          Figma Design System
        </Link>
      </Stack>
    </Stack>
  );
}
